import { createSelector } from 'reselect';
import { getQuery } from './querySelectors';

const australiaRegex = /(.*)Australia$/i;

export const getIsDomestic = createSelector(getQuery, (query) => {
  const isDomestic = australiaRegex.test(query?.location);

  return isDomestic;
});
